/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  OtelDestination,
  OtelDestination$inboundSchema,
} from "./oteldestination.js";

/**
 * Destination transport type.
 */
export const DestinationDestinationType = {
  Otel: "otel",
} as const;
/**
 * Destination transport type.
 */
export type DestinationDestinationType = OpenEnum<
  typeof DestinationDestinationType
>;

/**
 * Whether sensitive data is included in payloads sent to this destination.
 */
export const DestinationSensitiveData = {
  Exclude: "exclude",
  Include: "include",
} as const;
/**
 * Whether sensitive data is included in payloads sent to this destination.
 */
export type DestinationSensitiveData = OpenEnum<
  typeof DestinationSensitiveData
>;

/**
 * A reusable project-scoped data export destination. The destination_type discriminator identifies the populated transport configuration.
 */
export type Destination = {
  /**
   * Creation timestamp.
   */
  createdAt: Date;
  /**
   * Destination transport type.
   */
  destinationType: DestinationDestinationType;
  /**
   * Destination ID.
   */
  id: string;
  /**
   * Human-readable destination name.
   */
  name: string;
  /**
   * OTEL-specific destination configuration.
   */
  otel?: OtelDestination | undefined;
  /**
   * Project that owns the destination.
   */
  projectId: string;
  /**
   * Whether sensitive data is included in payloads sent to this destination.
   */
  sensitiveData: DestinationSensitiveData;
  /**
   * Last update timestamp.
   */
  updatedAt: Date;
};

/** @internal */
export const DestinationDestinationType$inboundSchema: z.ZodMiniType<
  DestinationDestinationType,
  unknown
> = openEnums.inboundSchema(DestinationDestinationType);

/** @internal */
export const DestinationSensitiveData$inboundSchema: z.ZodMiniType<
  DestinationSensitiveData,
  unknown
> = openEnums.inboundSchema(DestinationSensitiveData);

/** @internal */
export const Destination$inboundSchema: z.ZodMiniType<Destination, unknown> = z
  .pipe(
    z.object({
      created_at: z.pipe(
        z.iso.datetime({ offset: true }),
        z.transform(v => new Date(v)),
      ),
      destination_type: DestinationDestinationType$inboundSchema,
      id: z.string(),
      name: z.string(),
      otel: z.optional(OtelDestination$inboundSchema),
      project_id: z.string(),
      sensitive_data: DestinationSensitiveData$inboundSchema,
      updated_at: z.pipe(
        z.iso.datetime({ offset: true }),
        z.transform(v => new Date(v)),
      ),
    }),
    z.transform((v) => {
      return remap$(v, {
        "created_at": "createdAt",
        "destination_type": "destinationType",
        "project_id": "projectId",
        "sensitive_data": "sensitiveData",
        "updated_at": "updatedAt",
      });
    }),
  );

export function destinationFromJSON(
  jsonString: string,
): SafeParseResult<Destination, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => Destination$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'Destination' from JSON`,
  );
}
